import React, { useState } from 'react';
import { MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import { Typography, useTheme } from '@mui/material';
import { type SidebarItemProps } from './types/sidebar.types';

export const SidebarItem: React.FC<SidebarItemProps> = ({ 
  title, 
  to, 
  icon, 
  selected, 
  setSelected 
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();

  const menuItemStyle = {
    color: theme.palette.text.primary,
    backgroundColor: selected === title ? theme.palette.action.selected : "transparent",
    ...(isHovered && { backgroundColor: theme.palette.action.hover })
  };

  return (
    <MenuItem
      style={menuItemStyle}
      active={selected === title}
      onClick={() => setSelected(title)}
      icon={icon}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      component={<Link to={to} />}
    >
      <Typography style={{fontWeight: 600}}>{title}</Typography>
    </MenuItem>
  );
};

export const SidebarSubItem: React.FC<Omit<SidebarItemProps, 'icon'>> = ({ 
  title, 
  to, 
  selected, 
  setSelected 
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();

  const subMenuItemStyle = {
    paddingLeft: "40px",
    height: "40px",
    color: theme.palette.text.secondary,
    backgroundColor: selected === title ? theme.palette.action.selected : "transparent",
    ...(isHovered && { backgroundColor: theme.palette.action.hover })
  };

  return (
    <MenuItem
      style={subMenuItemStyle}
      active={selected === title}
      onClick={() => setSelected(title)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      component={<Link to={to} />}
    >
      <Typography style={{fontWeight: 500}}>{title}</Typography>
    </MenuItem>
  );
};